import { PictureText } from 'ui/components';

export const PictureTextFeature: React.FC<Content.PictureText> = ({ content, settings }) => {
	return (
	<PictureText {...content?.properties} pictureLast={settings?.properties.pictureLast}  />
)};
